import React, { useEffect } from 'react'
import * as Sentry from '@sentry/browser'
import { Route } from 'react-router-dom'
import { MagentoCountryCodeEnum } from 'lib/types'

// Core
import { localStorage } from 'lib/core/services/localStorage'
import { PWA, Switch } from 'lib/core/components'
import { loadScript } from 'lib/core/resources/helpers'
import { ConfirmAccount } from 'lib/shared/scenes/ConfirmAccount'
import { ThemeProvider } from 'lib/ui'
import { Main } from 'lib/modules/shared'

// Project
import { sofiaTheme } from 'app/sofia/resources/theme'
import { CMS_BLOCK as cmsBlocks } from 'app/sofia/resources/constants'
import { GlobalStyle } from './components/GlobalStyle'
import { ModalGlobalStyle } from 'components/Modal'
import { translations } from './resources/translations'
import { EntityResolver } from './components/EntityResolver'
import { Home } from './scenes/Home'
import { Layout } from './components/Layout'
import { Customer } from './scenes/Customer'
import { Login } from './scenes/Customer/scenes/Account/scenes/Login'
import { CreateAccount } from './scenes/Customer/scenes/Account/scenes/Create'
import { Cart } from './scenes/Cart'
import { Checkout } from './scenes/Checkout'
import { Blog } from './scenes/Blog'
import { Reviews } from './scenes/Reviews'
import { ProductSelector } from './scenes/ProductSelector'
import { Comparison } from './scenes/ProductComparison'
import { OrdersAndReturns } from 'scenes/OrdersAndReturns'
import { ContactUs } from './scenes/ContactUs'
import { SearchScene } from 'scenes/Search'
import { ForgotPassword } from 'scenes/ForgotPassword'
import { ResetPassword } from 'scenes/ResetPassword'

// CMS
import * as data from 'data'
import { ComparisonProvider } from 'lib/modules/catalog'
import { AbandonedCart } from 'app/sofia/scenes/AbandonedCart'

export const Index = () => {
  useEffect(() => {
    loadExternalResources()
  }, [])

  return (
    <PWA
      checkoutCountries={[MagentoCountryCodeEnum.US]}
      data={data}
      cmsBlocks={cmsBlocks}
      translations={translations}
      onError={(error, errorInfo) => {
        Sentry.withScope((scope) => {
          const user = localStorage.get('user')
          scope.setUser(user)
          scope.setExtras({
            errorInfo,
            user
          })
          Sentry.captureException(error)
        })
      }}
      route={{
        cart: { component: Cart },
        confirmAccount: { component: ConfirmAccount },
        checkout: { component: Checkout },
        createAccount: { component: CreateAccount },
        customer: { component: Customer },
        forgotPassword: { component: ForgotPassword },
        resetPassword: { component: ResetPassword },
        login: { component: Login },
        search: { component: SearchScene }
      }}
    >
      <ThemeProvider theme={sofiaTheme}>
        <Main layout={Layout}>
          <ComparisonProvider>
            <Layout>
              <Switch entityResolver={EntityResolver}>
                <Route exact path='/' component={Home} />
                <Route exact path='/cart/:abandonCartId' component={AbandonedCart} />
                <Route path='/blog' component={Blog} />
                <Route path='/reviews' component={Reviews} />
                <Route path='/product-selector' component={ProductSelector} />
                <Route path='/product-comparison' component={Comparison} />
                <Route path='/sales' component={OrdersAndReturns} />
                <Route path='/contact-us' component={ContactUs} />
              </Switch>
            </Layout>
          </ComparisonProvider>
          <ModalGlobalStyle />
        </Main>
        <GlobalStyle />
      </ThemeProvider>
    </PWA>
  )
}

const loadExternalResources = () => {
  const scripts = [
    'https://www.shopperapproved.com/widgets/testimonial/3.0/6658.js',
    '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
    'https://download.digiaccess.org/digiaccess'
  ]

  scripts.forEach(src => loadScript({ src }))
  setTimeout(setupLiveChat, 1000 * 20)
}

const setupLiveChat = () => {
  // @ts-expect-error
  window.__lc = window.__lc || {}
  // @ts-expect-error
  window.__lc.license = 1072327
  loadScript({ src: 'https://cdn.livechatinc.com/tracking.js' })
}
